import styled from 'styled-components'

export default styled.hr`
  height: 2px;
  border: none;
  background: #c8c8c8;
  margin: 30px 0 20px 0;
`
